<div class="widget">
  @let isWsOpen = isWsOpen$ | async;
  @let threadStatus = threadStatus$ | async;
  @let isCurrentUserThreadParticipant = isCurrentUserThreadParticipant$ | async;
  @let isMine = isMine$ | async;
  @if (!isWsOpen) {
    <div class="ws-error" i18n>The connection with the forum has been lost, try to refresh the current page.</div>
  } @else {
    @switch(state().tag) {
      @case('fetching') {
        <div class="widget-loading">Loading...</div>
      }
      @case('error') {
        <div class="widget-error">Error!</div>
      }
      @case('ready') {
        <div class="widget-body">
          @if (!isMine) {
            @if (participantUser$ | async; as participantUser) {
              @if (participantUser.name) {
                <div class="user-indicator-container">
                  <div class="user-indicator">
                    <span i18n>You are helping</span>
                    <a class="alg-link user-indicator-link" [routerLink]="[ '/groups/users', participantUser.id ]">{{ participantUser.name }}</a>
                  </div>
                </div>
              }
            }
          }
          <div class="widget-scroll" #messagesScroll *ngrxLet="{ id: threadId$ | async, userCache: userCache$ | async, canCurrentUserLoadAnswers: canCurrentUserLoadAnswers$ | async } as threadMetadata">
            @if (isCurrentUserThreadParticipant && threadStatus?.isReady && state().data?.length === 0) {
              <div class="no-messages" i18n>
              In this panel, you can request help from other users about the content you are on.
              People who have already validated this activity will see your request and be able to answer.
            </div>
            } @else {
              @if (threadMetadata.id) {
                @for (event of state().data; track event.time) {
                  <alg-thread-message
                    class="thread-message"
                    [threadId]="threadMetadata.id"
                    [event]="event"
                    [userCache]="threadMetadata.userCache ?? []"
                    [canCurrentUserLoadAnswers]="threadMetadata.canCurrentUserLoadAnswers ?? false"
                    [itemRoute]="threadMetadata.id ? ({ id: threadMetadata.id.itemId, type: 'Task' } | itemRoute) : undefined"
                  ></alg-thread-message>
                }
              }
            }
            @if (threadMetadata.id; as threadId) {
              <div class="footer-panel" *ngrxLet="!!(threadStatus && !!threadStatus.data && !!threadStatus.data.open) as isThreadOpened">
                <form class="send-form" [formGroup]="form" (ngSubmit)="sendMessage(threadId, isThreadOpened)">
                  <textarea
                    class="textarea"
                    placeholder="Send a message..."
                    formControlName="messageToSend"
                    [rows]="1"
                    algAutoResize
                    (keydown.enter)="$event.preventDefault(); sendMessage(threadId, isThreadOpened)"
                    #messageToSendEl
                  ></textarea>
                  <button
                    class="size-l with-bg send-button"
                    type="submit"
                    icon="pi pi-send"
                    alg-button-icon
                    [disabled]="!form.get('messageToSend')?.value?.trim() || !!(disableControls$ | async)"
                  ></button>
                </form>
                <div class="thread-status">
                  <div class="thread-status-caption" >
                    @if (threadStatus?.data?.open) {
                      <span i18n>This thread is open</span>
                    }
                    @if (threadStatus?.data?.open === false) {
                      <span i18n>This thread is closed</span>
                    }
                    @if (threadStatus?.isFetching) {
                      <span i18n>Loading thread status...</span>
                    }
                    @if (threadStatus?.isError) {
                      <span i18n>Error while loading thread info</span>
                    }
                    @if (threadStatus === undefined) {
                      <span i18n>Could not load thread</span>
                    }
                  </div>
                  <div
                    *ngrxLet="!!threadStatus && !!threadStatus.data && ((threadStatus.data.open && threadStatus.data.canClose) || (!threadStatus.data.open && threadStatus.data.canOpen)) as canSwitch"
                    [pTooltip]="threadStatusTooltip"
                    [tooltipDisabled]="canSwitch"
                    tooltipPosition="top"
                    tooltipStyleClass="alg-tooltip"
                    >
                    @if (threadStatus && threadStatus.data) {
                      <button
                        type="button"
                        [disabled]="!canSwitch"
                        alg-button
                        (click)="changeThreadStatus({ open: !threadStatus.data.open, threadId: threadId })"
                        >
                        @if (threadStatus.data.open) {
                          <span i18n>Close this thread</span>
                        } @else {
                          <span i18n>Open this thread</span>
                        }
                      </button>
                    }
                  </div>
                  <ng-template #threadStatusTooltip>
                    @if (threadStatus?.data?.open) {
                      <span i18n>
                      Only the user of the thread can close it.
                    </span>
                    } @else {
                      <span i18n>You are not allowed to open this thread.</span>
                    }
                  </ng-template>
                </div>
              </div>
            }
          </div>
        </div>
      }
    }
  }
</div>

